<script lang="ts">
	import CardBadge from '$lib/components/ui/CardBadge.svelte';
	import ImageHoverGallery from '$lib/components/ui/ImageHoverGallery.svelte';
	import type { ThumbnailCity } from '$lib/features/city/cityThumbnail.type';
	import { type NavLink, UrlUtil } from '$lib/utils/url.util';
	import { fly } from 'svelte/transition';
	import IconArrowRight from '~icons/mdi/arrow-right';

	const { city, eagerLoadCoverImage = false }: { city: ThumbnailCity; eagerLoadCoverImage?: boolean } = $props();

	let isCardHovered = $state<boolean>(false);
</script>

{const cityNav = $derived<NavLink>(UrlUtil.toCity({ countrySlug: city.country.slug, citySlug: city.slug }))}
<a
	class="group relative block aspect-4/3 w-full overflow-hidden rounded-box shadow-lg transition-all duration-500"
	title="View {city.englishName}"
	href="/{cityNav.href}"
	data-sveltekit-preload-data={cityNav.preloadData}
	data-sveltekit-preload-code={cityNav.preloadCode}
>
	<ImageHoverGallery
		images={city.images}
		eagerLoading={eagerLoadCoverImage}
		onHoverChange={(isHovered) => (isCardHovered = isHovered)}
	/>

	{#if !isCardHovered}
		{@render Gradient()}
	{/if}

	<div class="pointer-events-none absolute inset-0 flex flex-col justify-end p-8 text-white">
		{#if !isCardHovered}
			<div class="absolute top-6 right-6" in:fly={{ y: -20, duration: 300 }} out:fly={{ y: -20, duration: 300 }}>
				<CardBadge text={city.country.englishName.toUpperCase()} />
			</div>

			<div
				class="transform text-white transition-transform duration-500 group-hover:-translate-y-2"
				in:fly={{ y: 20, duration: 300 }}
				out:fly={{ y: 20, duration: 300 }}
			>
				<h3 class="text-4xl leading-none">
					{city.englishName}
				</h3>
			</div>
		{/if}

		<div
			class="absolute right-8 bottom-8 translate-y-8 opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100"
		>
			{@render CTA()}
		</div>
	</div>
</a>

{#snippet CTA()}
	<div class="btn btn-circle shadow-lg btn-primary">
		<IconArrowRight class="h-6 w-6" />
	</div>
{/snippet}

{#snippet Gradient()}
	<div
		class="pointer-events-none absolute inset-0 bg-linear-to-t from-black/90 via-black/60 to-transparent opacity-80 transition-opacity group-hover:opacity-90"
	></div>
{/snippet}
